"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Buttons = exports.Button = exports.ButtonArrow = exports.ButtonTextOverflow = exports.ButtonTextAlign = exports.ButtonShape = exports.ButtonSize = exports.ButtonAppearance = exports.ButtonColor = void 0;
var react_1 = __importStar(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Loader_1 = require("./Loader");
var Margin_1 = require("../utility/Margin");
var Icon_1 = require("./Icon");
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["Primary"] = "+1";
    ButtonColor["Secondary"] = "+2";
    ButtonColor["Quiet"] = "+quiet";
    ButtonColor["Positive"] = "+pos";
    ButtonColor["Negative"] = "+neg";
    ButtonColor["Warning"] = "+warn";
    ButtonColor["Reverse"] = "+rev";
})(ButtonColor = exports.ButtonColor || (exports.ButtonColor = {}));
var ButtonAppearance;
(function (ButtonAppearance) {
    /** Removes the fill and adds an outer stroke */
    ButtonAppearance["Ghost"] = "+ghost";
    /** Strips back the button to just the text, but occupies the same space */
    ButtonAppearance["Text"] = "+text";
})(ButtonAppearance = exports.ButtonAppearance || (exports.ButtonAppearance = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Small"] = "+small";
    ButtonSize["Large"] = "+large";
    ButtonSize["Inline"] = "+inline";
})(ButtonSize = exports.ButtonSize || (exports.ButtonSize = {}));
var ButtonShape;
(function (ButtonShape) {
    ButtonShape["Long"] = "+long";
    ButtonShape["Tighter"] = "+tighter";
    ButtonShape["Tight"] = "+tight";
})(ButtonShape = exports.ButtonShape || (exports.ButtonShape = {}));
var ButtonTextAlign;
(function (ButtonTextAlign) {
    /** Aligns to the left of the button */
    ButtonTextAlign["Start"] = "+start";
    /** Aligns to the right of the button */
    ButtonTextAlign["End"] = "+end";
})(ButtonTextAlign = exports.ButtonTextAlign || (exports.ButtonTextAlign = {}));
var ButtonTextOverflow;
(function (ButtonTextOverflow) {
    /** If the button text is too long it truncates and adds an ellipsis */
    ButtonTextOverflow["Overflow"] = "+overflow";
    /** Wraps the button text if it's too long */
    ButtonTextOverflow["Wrap"] = "+wrap";
})(ButtonTextOverflow = exports.ButtonTextOverflow || (exports.ButtonTextOverflow = {}));
var ButtonArrow;
(function (ButtonArrow) {
    ButtonArrow["Up"] = "+arrow-up";
    ButtonArrow["Right"] = "+arrow-right";
    ButtonArrow["Down"] = "+arrow-down";
    ButtonArrow["Left"] = "+arrow-left";
})(ButtonArrow = exports.ButtonArrow || (exports.ButtonArrow = {}));
var Button = function (props) {
    // Destructure our props, so that we can get the rest of our props to pass
    // through to our HTML input
    var appearance = props.appearance, color = props.color, size = props.size, shape = props.shape, textAlign = props.textAlign, textOverflow = props.textOverflow, arrow = props.arrow, arrowAlign = props.arrowAlign, noHover = props.noHover, icon = props.icon, onClick = props.onClick, disabled = props.disabled, allowOverlappingEvents = props.allowOverlappingEvents, allowEventPropagation = props.allowEventPropagation, busyExternally = props.busy, _a = props.component, Component = _a === void 0 ? "button" : _a, _b = props.loadingIndicatorComponent, LoadingIndicator = _b === void 0 ? (react_1.default.createElement(Loader_1.Loader, { styleOptions: { margin: Margin_1.Margin.Left } })) : _b, className = props.className, utilityAndButtonProps = __rest(props, ["appearance", "color", "size", "shape", "textAlign", "textOverflow", "arrow", "arrowAlign", "noHover", "icon", "onClick", "disabled", "allowOverlappingEvents", "allowEventPropagation", "busy", "component", "loadingIndicatorComponent", "className"]);
    // Track if we're busy - toggled during a button push.
    var _c = react_1.useState(false), busy = _c[0], setBusy = _c[1];
    var _d = distillUtilityClasses_1.default(utilityAndButtonProps), utilityClasses = _d[0], buttonProps = _d[1];
    var classes = __spreadArray(__spreadArray([
        "c-button",
        appearance,
        color,
        size,
        shape,
        textAlign,
        textOverflow,
        arrow,
        arrowAlign,
        disabled ? "+disabled" : "",
        busy || busyExternally ? "+busy" : "",
        noHover ? "+no-hover" : "",
        icon ? "+icon" : ""
    ], utilityClasses), [
        className && className,
    ]);
    var mounted = react_1.useRef(false);
    // The following useEffect is just here to track when we've been unmounted.
    // If we're disallowing overlapping events then the client event will set
    // a "busy" boolean, call the click event, and then reset the "busy" boolean.
    //
    // However if the click event itself causes the button to removed, then we
    // get a React warning about updating state on an unmounted component. The
    // mounted boolean lets us fence for that.
    //
    // This is common if for example the button is the one to close a dialog.
    react_1.useEffect(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    return (react_1.default.createElement(Component, __assign({ className: classes.join(" "), disabled: disabled || busy || busyExternally, onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!allowEventPropagation) {
                            e.stopPropagation();
                        }
                        if (!onClick) return [3 /*break*/, 3];
                        if (!!allowOverlappingEvents) return [3 /*break*/, 2];
                        // Disable while we're processing
                        setBusy(true);
                        // Call our click event and wait for it to return
                        return [4 /*yield*/, onClick(e)];
                    case 1:
                        // Call our click event and wait for it to return
                        _a.sent();
                        // See above for the discussion about the mounted flag.
                        if (mounted.current) {
                            // Re enable our button.
                            setBusy(false);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        // User doesn't want to wait - just call the event handler.
                        onClick(e);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); } }, buttonProps),
        props.children || props.content,
        (busy || busyExternally) && LoadingIndicator));
};
exports.Button = Button;
exports.Button.displayName = "Button";
exports.Button.Arrow = ButtonArrow;
exports.Button.ArrowAlign = ButtonTextAlign;
exports.Button.Color = ButtonColor;
/** Formerly Button.Type */
exports.Button.Appearance = ButtonAppearance;
/** @deprecated Use Button.Type */
exports.Button.Type = ButtonAppearance;
exports.Button.Size = ButtonSize;
exports.Button.Shape = ButtonShape;
exports.Button.TextAlign = ButtonTextAlign;
exports.Button.TextOverflow = ButtonTextOverflow;
var ButtonIcon = function (props) { return (react_1.default.createElement(Icon_1.Icon, __assign({}, props, { className: "c-button__icon" + (props.className ? " " + props.className : "") }))); };
var Buttons = function (props) {
    var _a = props.component, Component = _a === void 0 ? "div" : _a, utilityAndButtonsProps = __rest(props, ["component"]);
    var _b = distillUtilityClasses_1.default(utilityAndButtonsProps), utilityClasses = _b[0], buttonsProps = _b[1];
    var classes = __spreadArray(__spreadArray(["c-buttons"], utilityClasses), [buttonsProps.className]);
    return (react_1.default.createElement(Component, __assign({ className: classes.join(" ") }, buttonsProps), props.children));
};
exports.Buttons = Buttons;
exports.Buttons.displayName = "Buttons";
exports.Button.Group = exports.Buttons;
exports.Button.Icon = ButtonIcon;
//# sourceMappingURL=Button.js.map